/**
 * Frontend bridge to the payroll engine (A-1 / D-37).
 *
 * The engine lives in functions/Payroll/engine (pure CommonJS, no Node
 * builtins) and is imported DIRECTLY into the bundle — possible because
 * craco.config.js removes webpack's ModuleScopePlugin. This is the "one
 * engine, one code path" guarantee: the calculator runs the exact same
 * code as batch runs and backtests.
 *
 * If this import ever breaks the build, the pre-approved fallback (Q-2)
 * is a payrollCalculateComp callable — do NOT fork the engine into src/.
 */

import engineModule from '../../../functions/Payroll/engine';

export const engine = engineModule;

/**
 * Plain stored snapshot JSON (payrollGetReferenceSnapshot payload) →
 * engine-ready snapshot. Mirror of snapshotLoader.reviveSnapshot (backend),
 * which can't be bundled because it imports the Supabase admin client.
 */
export function reviveSnapshot(storable) {
  return {
    ...storable,
    splitRules: (storable.splitRules || []).map((r) => ({
      ...r,
      effective: r.effective ? new Date(r.effective) : null,
    })),
  };
}

export const {
  ENGINE_VERSION,
  PARITY_BASE,
  FLAG_VOCABULARY,
  TAGS,
  resolveDealSource,
  shareOf,
  resolvePricingContext,
  buildContext,
  matchSplitRule,
  matchFeeOverride,
  calculateCommission,
  evaluateRow,
  routePayees,
  buildCdCounts,
  toNum,
  num,
  round2,
  fmt,
  parseDate,
  canonicalEmail,
  isW2,
} = engineModule;

export default engineModule;
